// Commission Payable States

export default {
  commissionPayableList: [],
  commissionPayableInfo: {},
  commissionPayableBalanceDetails: {}
}
